/* Visibility scheduling only. Shopify discount rules remain authoritative. */
window.SimpsonHubSchedule = class {
  static timestamp(raw) {
    if (!raw) return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(raw);
    if (!match) return NaN;
    const [year, month, day, hour, minute, second] = match.slice(1, 7).map(value => Number(value || 0));
    if (year < 1970 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59 || second > 59) return NaN;
    const calendar = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return NaN;
    const zone = match[7];
    if (zone !== 'Z') {
      const hours = Number(zone.slice(1, 3)), minutes = Number(zone.slice(4, 6));
      if (hours > 14 || minutes > 59 || (hours === 14 && minutes !== 0)) return NaN;
    }
    return Date.parse(raw);
  }

  constructor(hub) {
    this.hub = hub;
    this.listeners = new AbortController();
    this.cards = Array.from(hub.querySelectorAll('[data-hub-schedule]'), element => ({
      element, start: this.constructor.timestamp(element.dataset.hubStart), end: this.constructor.timestamp(element.dataset.hubEnd)
    }));
    const options = { signal: this.listeners.signal };
    document.addEventListener('visibilitychange', () => this.update(), options);
    window.addEventListener('focus', () => this.update(), options);
    hub.querySelector('simpson-hub-drawer')?.addEventListener('toggle', () => this.update(), options);
    this.update();
  }

  update() {
    clearTimeout(this.timer);
    if (this.listeners.signal.aborted) return;
    const now = Date.now();
    let next = Infinity;
    for (const { element, start, end } of this.cards) {
      const invalid = Number.isNaN(start) || Number.isNaN(end) || (start !== null && end !== null && end <= start);
      const state = invalid ? 'invalid' : start !== null && now < start ? 'upcoming' : end !== null && now >= end ? 'expired' : 'active';
      element.dataset.hubScheduleState = state;
      element.hidden = state !== 'active';
      if (!invalid) for (const boundary of [start, end]) if (boundary !== null && boundary > now) next = Math.min(next, boundary);
      if (element.hidden && element.contains(document.activeElement)) {
        const view = element.closest('[data-hub-view]');
        if (this.hub.drawer?.open && view && !view.hidden) view.querySelector('h3[tabindex="-1"]')?.focus();
      }
    }
    for (const group of this.hub.querySelectorAll('.customer-hub__content-cards')) {
      group.hidden = Array.from(group.children).every(card => card.hidden);
    }
    const empty = this.hub.querySelector('[data-hub-offers-empty]');
    if (empty) empty.hidden = this.cards.some(card => card.element.matches('.customer-hub__coupon') && !card.element.hidden);
    // Recheck at boundaries and at least every minute, including clock changes.
    if (this.cards.some(card => card.start !== null || card.end !== null)) this.timer = setTimeout(() => this.update(), Math.max(1, Math.min(60000, next - now)));
  }

  destroy() {
    this.listeners.abort();
    clearTimeout(this.timer);
  }
};
